// extracted by mini-css-extract-plugin
export default {"productCartSection":"styles_productCartSection__KTwbr"};